export const RecurringTypes = {
  ONE_OFF: "One-off",
  MONTHLY: "Monthly",
  QUARTERLY: "Quarterly",
  YEARLY: "Yearly",
};
